import { apiCaller } from '@/api/apiCaller';
import { IUser } from '@/modules/user/models';
import { apihost } from '@/api/urls';

const getAll = (isOnlyActive: boolean) => apiCaller.getParams('/user/', apihost, { IsOnlyActive: isOnlyActive });
const addUser = (user: IUser) => apiCaller.post('/user/save', apihost, user);
const updateUser = (user: IUser) => apiCaller.put('/user/update', apihost, user);
const getUserProfiles = (id: number) => apiCaller.get(`/user/userprofile/${id}`, apihost);
const getUserFunctionalityRestrictions = (id: number) => apiCaller.get(`/user/userfunctionalityrestriction/${id}`, apihost);
const confirmemail = (id: number) => apiCaller.get(`/user/confirmemail/${id}`, apihost);
const deleteUserBonds = (id: number, bondIds: number[]) => apiCaller.post(`/user/deleteuserbonds/${id}`, apihost, bondIds);
const getUsersReport = () => apiCaller.getFile(`/user/usersreport`, apihost);
const getRoleClassifications = () => apiCaller.get(`/user/roleclassifications`, apihost);

export const userApi = {
  getAll,
  addUser,
  updateUser,
  getUserProfiles,
  getUserFunctionalityRestrictions,
  confirmemail,
  deleteUserBonds,
  getUsersReport,
  getRoleClassifications,
};
